import { AccountState } from './types'

const state: AccountState = {
  loggedIn: false,
  firstName: '',
  token: '',
  email: '',
  grade: '',
  year: '',
  courses: [],
  favorites: [],
  selectedBooks: {}
}

export default state
